import {makeStyles} from "@material-ui/core/styles";

export default makeStyles({
    root: {
        paddingTop: 50
    },
    dayReport: {
        marginBottom: 76
    }
})